import { DEFAULT_POSITION_SLOT_LIFECYCLE_FILTER } from 'domain/people/positionSlots/preview/constants';
import { buildPositionSlotsFilter } from 'domain/people/positionSlots/preview/List/filterState';
import type { PreviewPositionSlotListItem } from 'domain/people/positionSlots/preview/types';
import usePositionSlotsService from 'domain/people/positionSlots/preview/usePositionSlotsService';
import { DESC } from 'framework/list';
import type { CollectionViewParamsConfig } from 'framework/ViewTypes';
import { type FilterState } from 'framework/ViewTypes/components';
import { FilterCondition } from 'framework/types';
import { useCollectionPager } from 'framework/ViewTypes/hooks';
import { POSITION_SLOTS_STATE_VALIDATION } from 'domain/people/positionSlots/preview/List/viewParamsValidation';

const POSITIONS_VIEW_PARAMS_CONFIG: CollectionViewParamsConfig<FilterState> = {
  ...POSITION_SLOTS_STATE_VALIDATION,
  defaultFilters: {
    lifecycle: { [FilterCondition.IN]: DEFAULT_POSITION_SLOT_LIFECYCLE_FILTER },
  },
  defaultSortBy: 'createdAt',
  defaultSortOrder: DESC,
  syncWithUrl: false,
  cache: false,
};

const usePositionsCollection = (profileId: string, enabled: boolean) => {
  const { getPositionSlotsPage } = usePositionSlotsService();

  return useCollectionPager<PreviewPositionSlotListItem, FilterState>({
    pageSize: 30,
    collectionKey: profileId,
    enabled: enabled,
    viewParamsConfig: POSITIONS_VIEW_PARAMS_CONFIG,
    fetchPage: ({ pageNumber, pageSize, filters, searchValue, sort, signal }) =>
      getPositionSlotsPage(
        {
          pageNumber,
          pageSize,
          filter: {
            ...buildPositionSlotsFilter(filters, searchValue),
            positionProfileId: { [FilterCondition.EQ]: profileId },
          },
          sort,
        },
        { signal },
      ),
  });
};

export default usePositionsCollection;
